import { Injectable, Inject, HostListener, SecurityContext } from '@angular/core';
// import { Http, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ListingParams, CustomPageFiledValue, EmailData, AssessmentFormQuestionParams, TestData } from '../_models/common/listingParams';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ApiUrls } from '../_enums/apiUrls';
import { RouteUrls } from '../_enums/routeUrls';
import { SSOType, StatusCode } from '../_enums/Common';
import { SystemPages } from '../_enums/systemPages';
import { Deferred } from 'ts-deferred';
import { TitleService } from './title.service';
import { FileInfo } from '../_models/common/BaseModel';
import { Location } from '@angular/common';
// import { retry } from 'rxjs/operators';
// import { read } from 'fs';
import { DataViewService } from './data-view.service';
import * as moment from 'moment-mini-ts';
import { NotificationService } from '../notifications/toastr-notification.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DynamicScriptLoaderService } from './dynamicScriptLoaderService';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertService } from './alert.service';
import { IAngularMyDpOptions } from 'angular-mydatepicker';
import { ClientConfiguation } from '../_enums/clientConfiguration';
import { PasswordSettings } from '../_models/common/userInfo';
import { forkJoin, Observable } from 'rxjs';
import { KeyValue } from '@shared/interface/Icommon';
import { SystemListingPageField } from '../interface/appDataView/app-data-view.interface';
import { ContentType, ExtensionType } from '../_enums/reportBuilder';
import { IndexDBFormTypes } from '../_components/assessmentFormTest/interface/assessment-form-test.interface';
declare const html2canvas: any;
declare const jsPDF: any;
// import { setTimeout } from 'timers';

@Injectable(

)
export class CommonService {
  constructor(private deviceService: DeviceDetectorService, private router: Router,
    private route: ActivatedRoute,
    // private http: Http,
    private http: HttpClient,
    private translate: TranslateService,
    public Loader: Ng4LoadingSpinnerService,
    public Notification: NotificationService,
    // public _Notification:NotificationService,
    private titleService: TitleService,
    private dataViewService: DataViewService, @Inject('BASE_URL') baseUrl: string,
    private _location: Location,
    public dynamicScripts: DynamicScriptLoaderService,
    private _sanitizer: DomSanitizer,
    private alertService: AlertService,

  ) {
    this.listingParams = this.initListingParams();
    this.SetListingDefault();
    this.animationState = 'hide';
    this._baseUrl = baseUrl;
    this.serviceUrl = this.GetFromLocalStorage('gatewayUrl');
    try {
      const setting = this.getSettings();
      this.serviceUrl = setting.GatewayUrl;
      this.storageKey = setting.StorageKey;
      this.ssoConfig = setting.SSOConfig;
      this.clientIdentifier = setting.ClientSetting.ClientName;
      // localStorage.setItem('gatewayUrl');
    } catch (e) {
      console.log(e);
    }



    this.ckeConfig = {
      allowedContent: false,
      forcePasteAsPlainText: true
    };
  }
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  public passdata: any;
  gatewayUrl: any;
  public serviceUrl;
  public fieldCounter = 0;
  public isPreviousColumnBlank = false;
  public storageKey;
  public ssoConfig;
  public MenuClassesParent = 'col-xs-12 col-sm-10 widthfixexpanded';
  public listingParams = {} as ListingParams;
  public assessmentFormQuestionParams = {} as AssessmentFormQuestionParams;
  public ApiUrls = ApiUrls;
  public RouteUrls = RouteUrls;
  public SystemPages = SystemPages;
  public StatusCode = StatusCode;
  public HeaderMenu: string = '';
  public menuItemClick: string = '';
  public pageHeading: string = '';
  public docType: string = '';
  public _baseUrl;
  public ckeConfig: any;
  public componentLoaded = 0;
  public checkComponentLoaded = false;
  public selectedRecord: any[] = [];
  public emailData = {} as EmailData;
  public testData = {} as TestData;
  public animationState: string = 'hide';
  public innerWidth: number = 0;
  isReportBuilderAllowed: boolean = false;
  featureReportBuilder: boolean = false;
  //public html2canvas: any;
  //public jsPDF: any;
  public password_settings = {
    minLength: 8,
    maxLength: 25,
    specialLength: 1,
    upperLength: 1,
    numberLength: 2,
    barWidth: 200,
    barColor: 'Red',
    specialChars: '!@#$%&*()_+{}:;.?',
    metRequirement: false

  };
  public message: string = "";
  public clientIdentifier;

  public multiConfig = {
    displayKey: 'text',
    search: true,
    placeholder: 'Please Select',
    height: '250px'
  };


  AngularMyDpOption: IAngularMyDpOptions = {
    todayTxt: 'Today',
    showFooterToday: true,
    dateFormat: 'dd-mm-yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    disableWeekends: false,


  };

  public SetListingDefault() {
    this.listingParams.isAscendingSort = true;
    this.listingParams.pageSize = 20;
    this.listingParams.isSearchEnabled = false;
    this.listingParams.customfieldValues = [];
    this.listingParams.customfieldTranslationKeys = [];
    this.listingParams.textToSearch = '';
    this.listingParams.searchHeadingTranslationKey = '';

  }

  public cleanExtraCharactors(content: string) {
    content = content.replace(new RegExp('&lt;&lt;', 'g'), '{');
    content = content.replace(new RegExp('&gt;&gt;', 'g'), '}');
    content = content.replace(new RegExp('&nbsp;', 'g'), ' ');
    content = content.replace(new RegExp('&amp;nbsp;', 'g'), ' ');
    content = content.replace(new RegExp('&lt;', 'g'), '<');
    content = content.replace(new RegExp('&gt;', 'g'), '>');
    // content = content.replace(new RegExp('&lt;', 'g'), '"');
    return content;
  }

  public getBrowserInfo(): string {

    return this.deviceService.userAgent;
  }
  public getBrowserVersion(): string {

    return this.deviceService.browser_version;
  }

  public IsIEBrowser(): boolean {
    let isIE11Browser = false;
    const browser = this.getBrowserInfo();
    if (browser.indexOf('Trident/') > -1 && browser.indexOf('rv:11') > -1) {
      isIE11Browser = true;
    } else {
      isIE11Browser = false;
    }
    return isIE11Browser;
  }
  public IsEdgeBrowser(): boolean {
    let isedgeBrowser = false;
    const browser = this.getBrowserInfo();
    if (/Edge/.test(browser) || /Edg/.test(browser)) {
      isedgeBrowser = true;
    } else {
      isedgeBrowser = false;
    }
    return isedgeBrowser;
  }


  public getSettings(): any {

    return this.JsonParseData(document.getElementById('setting-container')?.getAttribute("data-settings"));
  }
  public getClientSettings(): any {

    const settings = this.JsonParseData(document.getElementById('setting-container')?.getAttribute("data-settings"));
    return settings.ClientSetting;
  }
  public getQuestionTypeName(qType?: string): string {
    let sS = '';
    switch (qType) {
      case 'S':
        sS = 'Multi-Choice (One Answer)';
        break;
      case 'M':
        sS = 'Multi-Choice (More than one Answer)';
        break;
      case 'O':
        sS = 'Order of Importance';
        break;
      case "T":
        sS = "Text";
        break;
      case 'D':
        sS = 'Multi-Choice (One Answer in each row - defined Options)';
        break;
      case 'C':
        sS = 'Multi-Choice (One Answer in each column)';
        break;
      case 'R':
        sS = 'Short Text';
        break;
      case 'H':
        sS = 'Section-Header';
        break;
      case 'I':
        sS = 'Instructions';
        break;
      case 'A':
        sS = 'Date';
        break;

    }

    return sS;
  }
  get(api: string, tokenParam?: string) {
    if (tokenParam == undefined) {
      tokenParam = "";
    }
    let token = '';
    if (this.isNullOrWhiteSpace(tokenParam)) {
      token = this.GetFromLocalStorage('auth_token');
    } else {
      token = tokenParam;
    }

    if (this.isNullOrWhiteSpace(token)) {
      token = '';
    }

    const headers = new
      HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Expose-Headers': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': '*',
        'Authorization': token
      });

    // console.log(token);
    // headers.append('Authorization', token);
    const options = { headers: headers };
    return this.http
      .get(this.serviceUrl + api, options);
    // .map(response => response.json());
  }

  post(api: string, data: any, tokenParam?: string | null) {
    if (tokenParam == undefined) {
      tokenParam = "";
    }
    let token = '';
    if (this.isNullOrWhiteSpace(tokenParam)) {
      token = this.GetFromLocalStorage('auth_token');
    } else {
      token = tokenParam;
    }
    if (this.isNullOrWhiteSpace(token)) {
      token = '';
    }
    let headers = new HttpHeaders();
    if (token != null && token != '') {
      headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': '*',
        'Authorization': token
      });
    } else {
      headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': '*',
        'Authorization': token
      });
    }
    // headers.append('Authorization', localStorage.getItem('auth_token'));
    const options = { headers: headers };
    return this.http
      .post(this.serviceUrl + api, JSON.stringify(data), options);
    // .map(response => response.json());

  }

  save(api: string, data: any) {
    const token = this.GetFromLocalStorage('auth_token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS', 'Access-Control-Allow-Headers': '*',
      'Authorization': token
    });
    // headers.append('Authorization', localStorage.getItem('auth_token'));
    const options = { headers: headers };
    if (data.id > 0) {
      return this.http
        .put(this.serviceUrl + api + "/" + data.id, JSON.stringify(data), options)
        .map((response: any) => response.json());
    }
    else {
      return this.http
        .post(this.serviceUrl + api, JSON.stringify(data), options)
        .map((response: any) => response.json());
    }
  }

  public SaveAndNotify(apiUrl: string, data: any, navigateUrl?: string | null, navigateParams?: any, messageKey?: string | null, saveMsg = false, pageUrl = "") {
    const d = new Deferred<any>();


    const p = d.promise;
    this.Loader.show();
    this.post(apiUrl, data, "")
      .subscribe((data: any) => {
        let result: any;
        try {

          if (typeof data == 'string') {
            result = this.JsonParseData(data);
          } else {
            result = data;
          }
          // result = JSON.parse( data.json());
        } catch (e) {

        }

        if (result.status == StatusCode.OK) {
          messageKey = (messageKey != null && messageKey != undefined) ? messageKey : 'Messages.Save';
          this.Notification.success(this.GetTranslation(messageKey), false, saveMsg);

          if (!this.isNullOrWhiteSpace(navigateUrl) && navigateUrl != undefined) {
            this.NavigateToRoute(navigateUrl, navigateParams);
          }

          else if (!this.isNullOrWhiteSpace(pageUrl)) {
            setTimeout(() => {
              window.location.href = pageUrl;
            }, 3000);
          }

          this.Loader.hide();
          d.resolve(result);
        }
        else {
          (messageKey != null && messageKey != undefined) ? this.Notification.error(this.GetTranslation(messageKey)) : this.Notification.error(this.GetTranslation("Messages.Error"));
        }
      }, error => {
        this.Loader.hide();
        this.Notification.error(this.GetTranslation('Messages.Error')); console.log('erre', error);
      });
    return p;
  }

  public GetData(apiUrl: string, showLoader?: boolean | undefined, token?: string | undefined): Promise<any> {


    let d = new Deferred<any>();
    let p = d.promise;

    try {
      if (apiUrl == 'undefined' || apiUrl == null || apiUrl == "") {
        d.reject("e");
        return p;
      }

      if (showLoader)
        this.Loader.show();

      this.get(apiUrl, token).subscribe(data => {
        let result: any;
        if (typeof data == 'string') {
          result = this.JsonParseData(data);
        } else {
          result = data;
        }

        d.resolve(result);
        if (showLoader) {
          this.Loader.hide();
        }
      }, error => {
        console.log('erre', error);
        this.Loader.hide();
      });
      return p;
    }
    catch (e) {
      d.reject(e);
      return p;
    }
  }

  public PostData(apiUrl: string, data: any, showLoader?: boolean, token?: string | null): Promise<any> {
    let d = new Deferred<any>();
    let p = d.promise;
    try {
      if (apiUrl == 'undefined' || apiUrl == null || apiUrl == "") {
        d.reject("e");
        return p;
      }
      if (showLoader)
        this.Loader.show();

      this.post(apiUrl, data, token).subscribe(data => {

        let result: any;
        if (typeof data == 'string') {
          result = this.JsonParseData(data);
        } else {
          result = data;
        }
        d.resolve(result);
        if (showLoader) {
          this.Loader.hide();
        }
      },
        error => {
          console.log('error', error);
          this.Loader.hide();
          d.reject(error);
        }
      );
      return p;
    }
    catch (e) {
      d.reject(e);
      return p
    }


  }

  public ForkJoinPostData(apiUrl: string, data: any, token?: string | null): Promise<any> {
    let d = new Deferred<any>();
    let p = d.promise;
    try {
      if (apiUrl == 'undefined' || apiUrl == null || apiUrl == "") {
        d.reject("e");
        return p;
      }
      this.post(apiUrl, data, token).subscribe(data => {
        let result: any;
        if (typeof data == 'string') {
          result = this.JsonParseData(data);
        } else {
          result = data;
        }
        d.resolve(result);
      },
        error => {
          console.log('error', error);
          this.Loader.hide();
          d.reject(error);
        }
      );
      return p;
    }
    catch (e) {
      d.reject(e);
      return p
    }
  }

  public makeConditionalParallelCalls(conditions: boolean[], endpoints: KeyValue<string, object>[]): Observable<any[]> {
    debugger
    const observables = [];
    for (let i = 0; i < conditions.length; i++) {
      if (conditions[i]) {
        observables.push(this.ForkJoinPostData(endpoints[i].text, endpoints[i].value));
      }
    }
    return forkJoin(observables);
  }

  public SaveData(apiUrl: string, data: any, navigateUrl?: string | null, queryParams?: any, messageKey?: string | null, saveMsg = false): Promise<any> {

    let d = new Deferred<any>();
    let p = d.promise;
    try {

      if (apiUrl == 'undefined' || apiUrl == null || apiUrl == "") {
        d.reject("e");
        return p;
      }

      this.Loader.show();
      this.PostData(apiUrl, data, true).then(data => {
        const result = data;
        if (result.status == StatusCode.Conflict) {
          this.Notification.info(this.GetTranslation("Messages.AlreadySaved"));
        }
        else if (result.status == StatusCode.Restricted)
          this.Notification.info(this.GetTranslation('Messages.AccessRestricted'));

        else if (result.status == StatusCode.OK) {
          messageKey = (messageKey != null && messageKey != undefined) ? messageKey : "Messages.Save";
          this.Notification.success(this.GetTranslation(messageKey), false, saveMsg);
          if (navigateUrl != null && navigateUrl != undefined) {
            this.NavigateToRouteWithQueryString(navigateUrl, queryParams);
          }
        } else {
          this.Notification.error(this.GetTranslation('Messages.Error'));
        }
        this.Loader.hide();
        d.resolve(result);
      });
      return p;
    } catch (e) {
      d.reject(e);
      return p
    }


  }
  update(api: string, id: number, data: any) {

    try {
      const token = this.GetFromLocalStorage('auth_token');
      const headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS', 'Access-Control-Allow-Headers': '*',
        'Authorization': token
      });
      //  headers.append('Authorization', localStorage.getItem('auth_token'));
      const options = { headers: headers };
      return this.http
        .put(this.serviceUrl + api + "/" + id, JSON.stringify(data), options)
        .map((response: any) => response.json());
    } catch (e) {

    }


  }

  delete(api: string, data: any) {
    const token = this.GetFromLocalStorage('auth_token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });
    // headers.append('Authorization', localStorage.getItem('auth_token'));

    const options = { headers: headers, body: data };
    return this.http
      .delete(this.serviceUrl + api + "/" + data.id, options)
      .map((response: any) => response.json());
  }
  getTranslateFile() {
    return this.JsonParseData(this.GetFromSessionStorage(this.translate.currentLang));
  }
  public loadTranslation() {


    if (this.router.url !== '/') {
      let lang = this.translate.currentLang;
      if (lang == null || lang == '') {
        lang = 'en';
      }
      let translation = null;
      try {
        translation = this.JsonParseData(this.GetFromSessionStorage(lang));
      } catch (e) {

      }
      if (translation == null) {
        return;
      }
      const url = 'Translation/GetTranslationFile' + '?language=' + lang;
      this.get(url).subscribe(data => {
        this.SetSessionStorage(lang, JSON.stringify(data.toString()));
      }, error => { });
    }
  }
  public GetTranslation(key: string) {

    let translation = this.getTranslateFile();
    if (key.length > 0) {
      const sections = key.split('.');
      for (let i = 0; i < sections.length; i++) {
        translation = translation[sections[i]];
      }
    }
    return translation;
  }

  public PadLeft(num: string, size: number): string {
    let s = num + '';
    while (s.length < size) { s = '0' + s; }
    return s;
  }

  public NavigateToRoute(routeName: string, params?: any) {
    if (params == undefined || params == null) {
      this.router.navigate([routeName]);
    } else {
      this.router.navigate([routeName], params);
    }
  }

  public NavigateToRouteWithQueryString(routeName: string, queryParams?: any) {
    if (queryParams == undefined || queryParams == null) {
      this.router.navigate([routeName]);
    } else {
      this.router.navigate([routeName], queryParams);
    }
  }

  SetMenuClasses(menuClasses: string): void {
    this.MenuClassesParent = menuClasses;
  }

  public UpperCase(value: string): string {
    if (value == null || value == undefined) {
      return value;
    } else {
      return value.toUpperCase();
    }
  }
  public LowerCase(value: string): string {
    if (value == null || value == undefined) {
      return value;
    } else {
      return value.toLowerCase();
    }
  }
  public setTitle(title: string): void {
    this.titleService.setTitle(title);
  }
  public getDocumentTitle(): string {
    return this.titleService.getDocumentTitle();
  }
  public sendMessage(message: string): void {
    this.titleService.sendMessage(message);
  }
  public reloadGrid(param: ListingParams): void {
    this.dataViewService.setgridReloadParam(param);
  }
  public GetPermissions() {
    return this.JsonParseData(this.GetFromLocalStorage('jt_permissions'));
  }
  public GetSecurityRole() {
    return this.JsonParseData(this.GetFromLocalStorage('jt_security_role'));
  }
  public GetLoggedinUserInfo() {
    return this.JsonParseData(this.GetFromLocalStorage('jt_user_info'));
  }
  public SetAccessToken(data: string) {
    this.SetLocalStorage('expiredToken', 'Bearer ' + data);
    return this.SetLocalStorage('auth_token', 'Bearer ' + data);
  }
  public ChangeToBearerToken(token: string) {
    return 'Bearer ' + token;
  }
  public GetAccessToken() {
    return this.GetFromLocalStorage('auth_token');
  }
  public RemoveAccessToken() {
    return this.RemoveLocalStorage('auth_token');
  }
  public GetDateFormat() {
    var dateformat = this.GetFromLocalStorage('jt_date_format');
    if (this.isNullOrWhiteSpace(dateformat))
      dateformat = "dd/MM/yyyy";
    return dateformat?.toLowerCase().replace(/m/g, "M");
  }
  public GetFromLocalStorage(key: string): string {
    key = this.storageKey + key;
    try {
      return localStorage.getItem(key) ?? "";

    } catch (e) {
      return localStorage.getItem(key) ?? "";
    }
  }
  public SetLocalStorage(key: string, data: any) {
    key = this.storageKey + key;
    localStorage.setItem(key, data);
  }
  public RemoveLocalStorage(key: string) {
    key = this.storageKey + key;
    localStorage.removeItem(key);
  }

  public GetFromSessionStorage(key: string) {
    key = this.storageKey + key;
    try {
      return sessionStorage.getItem(key);

    } catch (e) {
      return sessionStorage.getItem(key);
    }
  }
  public SetSessionStorage(key: string, data: string) {
    key = this.storageKey + key;
    sessionStorage.setItem(key, data);
  }
  public RemoveSessionStorage(key: string) {
    key = this.storageKey + key;
    sessionStorage.removeItem(key);
  }
  public RemoveAllSessionStorage() {
    const translation = this.GetFromSessionStorage(this.translate.currentLang) ?? "";
    sessionStorage.clear();
    this.SetSessionStorage(this.translate.currentLang, translation);
  }
  public GetWhiteLabelPermissions() {
    return this.JsonParseData(this.GetFromLocalStorage('whiteLabel_permissions'));
  }
  GetFileInfo(event: any, validTypes: string[], fileSize: number, validationMessage: string='') {
    const d = new Deferred<FileInfo>();
    const p = d.promise;
    if (this.isNullOrWhiteSpace(validationMessage))
      validationMessage = 'Messages.FileType';

    const file = event.target.files[0];
    let extention = '.';
    if (file.name.indexOf('.') > 0) {
      const nameArr = file.name.split('.');
      extention += nameArr[nameArr.length - 1];
    }

    if (validTypes.findIndex(d => d.toLowerCase() == extention.toLowerCase()) > -1) {

      if (file.size <= fileSize) {
        const reader = new FileReader();
        if (extention.toLowerCase() === ExtensionType.json) {
          reader.onload = () => {
            const fileInfo = {} as FileInfo;
            fileInfo.name = file.name;
            fileInfo.type = file.type;
            fileInfo.extention = extention;
            fileInfo.content = reader.result as string; // Get the content as a string
            d.resolve(fileInfo);
          };
          reader.readAsText(file); // Read the file content as text
        }
        else {
          reader.onload = () => {
            const fileInfo = {} as FileInfo;
            fileInfo.name = file.name;
            fileInfo.type = file.type;
            fileInfo.extention = extention;
            fileInfo.content = reader.result?.toString().split(',')[1] ?? "";
            d.resolve(fileInfo);
          };
          reader.readAsDataURL(file);
        }
      } else {
        this.Notification.error(this.GetTranslation('Messages.FileSize'));
      }
    } else {
      this.Notification.error(validationMessage);
    }

    return p;
  }

  DownLoadFile(fileInfo: FileInfo) {

    const url = !this.isNullOrWhiteSpace(fileInfo.extention) && fileInfo.extention == ContentType.json ? this.GetJsonObjectURL(fileInfo.content, fileInfo.extention) : this.GetObjectURL(fileInfo.content, fileInfo.extention);
    if (window.navigator.userAgent.toLowerCase().indexOf('trident') > -1) {


      // const blob = new Blob([fileInfo.content], { type: this.GetDocType(fileInfo.extention) });

      const blob = this.Base64toBlob(fileInfo.content, this.GetDocType(fileInfo.extention));
      window.navigator.msSaveBlob(blob, fileInfo.name);


    }
    // this code is added for edge  download file issue
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      const blob = this.Base64toBlob(fileInfo.content, this.GetDocType(fileInfo.extention));
      window.navigator.msSaveOrOpenBlob(blob, fileInfo.name);
    } else {
      const link = document.createElement('a');
      document.body.appendChild(link);
      link.href = url;
      link.download = fileInfo.name;

      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }

  public Base64toBlob(b64Data: string, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }


  PreviewFile(fileInfo: FileInfo) {
    const url = this.GetObjectURL(fileInfo.content, fileInfo.extention);

    window.open(url, '_blank');
  }

  PreviewHtml(fileInfo: FileInfo) {
    const url = "about:blank";
    const docUrl = window.open(url, '_blank');
    docUrl?.document.write(fileInfo.content);
    docUrl?.document.close();
  }

  FileURL(fileInfo: FileInfo) {
    return this.GetObjectURL(fileInfo.content, fileInfo.extention);
  }


  GetObjectURL(base64String: string, fileExtention: string) {
    const binaryString = window.atob(base64String);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return URL.createObjectURL(new Blob([bytes.buffer], { type: this.GetDocType(fileExtention) }));

  }
  GetJsonObjectURL(jsonString: string, fileExtension: string) {
    const blob = new Blob([jsonString], { type: this.GetDocType(fileExtension) });
    return URL.createObjectURL(blob);
  }


  GetDocType(type: string) {

    if (type) {
      switch (type.toUpperCase()) {
        case '.DOC':
          this.docType = 'Application/msword';
          break;
        case '.DOCX':
          this.docType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        case '.TXT':
          this.docType = 'text/plain';
          break;
        case '.GIF':
          this.docType = 'Image/GIF';
          break;
        case '.JPG':
          this.docType = 'Image/JPEG';
          break;
        case '.JPEG':
          this.docType = 'Image/JPEG';
          break;
        case '.XLS':
          this.docType = 'Application/vnd.ms-excel';
          break;
        case '.XLSX':
          this.docType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          break;
        case '.PPTX':
          this.docType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
          break;
        case '.PPT':
          this.docType = 'application/vnd.ms-powerpoint';
          break;
        case '.PDF':
          this.docType = 'application/PDF';
          break;
        case '.PNG':
          this.docType = 'image/png';
          break;
      }
    }

    return this.docType;
  }

  public GetPoints() {
    const points: number[] = [];
    for (let i = 0; i <= 12; i++)
      points.push(i);

    return points;
  }

  public exportReportToPdf() {


    const $element = document.getElementById('exportTable');
    this.HtmlToFileDownload($element, 'testFile.pdf');
  }

  public HtmlToFileDownload($element: any, fileName: string) {
    this.Loader.show();
    this.dynamicScripts.load('htmltocanvas').then(data => {
      this.dynamicScripts.load('pdf').then(data => {
        html2canvas($element).then((canvas: { toDataURL: (arg0: string) => any; height: number; width: number; }) => {
          const imgData = canvas.toDataURL('image/png');
          const doc = new jsPDF('p', 'mm');
          const imgWidth = 210;
          const pageHeight = 295;
          const imgHeight = canvas.height * imgWidth / canvas.width;
          let heightLeft = imgHeight;
          let position = 0;
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          doc.save(fileName);
          this.Loader.hide();
        }).catch((ex: any) => {
          console.log('ex', ex);
        });
      });
    });
  }

  public GoBack() {
    this._location.back();
  }

  public setLoader() {

    this.componentLoaded++;
    if (this.componentLoaded > 1) {
      this.Loader.hide();
    }
  }

  public checkPassword(password: any) {
    if (password) {
      let totalLenght = 0;
      let numberOfDigits = 0;

      totalLenght = password.length;
      numberOfDigits = password.replace(/[^0-9]/g, '').length;

      if (totalLenght < 7 || numberOfDigits < 2) {
        return this.GetTranslation('Settings.SystemUsers.Create.PasswordRequirementDescription');
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  public AnimatePage() {

    this.animationState = 'hide';
    if (this.animationState == 'hide') {
      // this.animationState = "show"
      setTimeout(() => { this.animationState = 'show', 500; });
    }
  }
  public stringToInt(str: string): number {

    if (this.isNullOrWhiteSpace(str)) {
      return 0;
    } else {
      return parseInt(str);
    }
  }
  public RedirectToLogin() {
    const loginUrl = 'Login';
    this.ClearLocalStorageOnlogOut();
    window.location.assign(loginUrl);
    // window.location.href = loginUrl;
  }

  logOut(relaod = true, clearToken = true) {
    const $that = this;
    let nextUrl = 'Login';
    let ssoConfig = this.ssoConfig;
    if (ssoConfig != undefined && ssoConfig.SingleSignOn === 'Yes' && ssoConfig.SingleSignOn_Type == SSOType.Okta) {
      nextUrl = "Logout";
    }

    try {
      this.PostData(this.ApiUrls.SystemUser.RevokeToken, null, true).then(function (data) {
        if (data.status == StatusCode.OK) {

          $that.ClearLocalStorageOnlogOut(clearToken);
          if (relaod) {
            window.location.href = nextUrl;
          }
        } else {
          window.location.href = nextUrl;
          $that.Notification.error($that.GetTranslation('Messages.Error'));
        }
      }).catch(function (data) {
        $that.ClearLocalStorageOnlogOut(clearToken);
        window.location.href = nextUrl;

      });

    } catch (e) {

      $that.ClearLocalStorageOnlogOut(clearToken);
      window.location.href = nextUrl;
    }

  }
  public ClearLocalStorageOnlogOut(clearToken = true): void {
    try {
      const $that = this;
      const userInfo = this.GetLoggedinUserInfo();
      let id = 0;
      if (!this.isNullOrWhiteSpace(userInfo)) {
        id = userInfo.id;
      }
      $that.RemoveLocalStorage('en');
      if (clearToken) {
        $that.RemoveAccessToken();
      }
      $that.RemoveLocalStorage('jt_permissions');
      $that.RemoveLocalStorage('jt_user_info');
      $that.RemoveLocalStorage('QuickLinks');
      $that.RemoveLocalStorage('QuickLinksLogoAndNotifications_' + id);
      $that.RemoveLocalStorage('TotalNotifications');
      $that.RemoveLocalStorage('NotificationCount');
      $that.RemoveLocalStorage('whiteLabel_permissions');
      $that.RemoveLocalStorage('cookieJTMessage');
      $that.RemoveLocalStorage('DynamicStyles');


      sessionStorage.clear();
    } catch (e) {
      console.log(e);
    }

  }

  public randomIntFromInterval(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  public formatDate(d: any, format?: string | null, appendTime = false) {
    if (format == null || format == '') {
      format = this.GetDateFormat()?.toUpperCase();
    }
    if (appendTime)
      format = format + " HH:mm";
    if (d == null || d == '') {
      return '';
    } else {
      if (new Date(d).getFullYear().toString() == '1900') {
        return '';
      }
      const date = moment(d);
      const dateInFormat = date.format(format);
      return dateInFormat;
    }
  }

  public formatDate1(d: string, format?: string) {
    if (format == null || format == '') {
      format = this.GetDateFormat()?.toUpperCase();
    }
    if (d == null || d == '' || d == '1900-01-01T00:00:00.0000000' || d == '1900-01-01T00:00:00') {
      return '';
    } else {
      if (new Date(d).getFullYear().toString() == '1900') {
        return '';
      }
      const date = moment(d);
      const dateInFormat = date.format(format);
      return dateInFormat;
    }
  }

  public getDayDiff(startDate: Date, endDate: Date): number {
    startDate = new Date(startDate);
    const msInDay = 24 * 60 * 60 * 1000;
    if (startDate != undefined && endDate != undefined) {
      return Math.round(
        Math.abs(endDate.getTime() - startDate.getTime()) / msInDay,
      );
    } else {
      return 0;
    }
  }


  public GetPasswordStrengthInfo(passwordVal: string, password_settings?: PasswordSettings) {
    if (password_settings) {
      this.password_settings.minLength = password_settings.minLength == 0 ? this.password_settings.minLength : password_settings.minLength;
      this.password_settings.maxLength = password_settings.maxLength == 0 ? this.password_settings.maxLength : password_settings.maxLength;
      this.password_settings.specialChars = password_settings.specialChars == '' ? this.password_settings.specialChars : password_settings.specialChars;
      this.password_settings.upperLength = password_settings.upperLength == 0 ? this.password_settings.upperLength : password_settings.upperLength;
      this.password_settings.numberLength = password_settings.numberLength == 0 ? this.password_settings.numberLength : password_settings.numberLength;
      this.password_settings.specialLength = password_settings.specialLength == 0 ? this.password_settings.specialLength : password_settings.specialLength;
    }
    if (!passwordVal) {
      passwordVal = '';
    }
    const len = passwordVal.length;
    let pStrength = 0;
    let msg = '', inValidChars = '';
    const allowableSpecilaChars = new RegExp('[' + this.password_settings.specialChars + ']', 'g');
    let nums = this.CountRegExp(passwordVal, /\d/g),
      lowers = this.CountRegExp(passwordVal, /[a-z]/g),
      uppers = this.CountRegExp(passwordVal, /[A-Z]/g),
      specials = this.CountRegExp(passwordVal, allowableSpecilaChars),
      spaces = this.CountRegExp(passwordVal, /\s/g);
    inValidChars = passwordVal.replace(/[a-z]/gi, '') + inValidChars.replace(/\d/g, '');
    inValidChars = inValidChars.replace(/\d/g, '');
    inValidChars = inValidChars.replace(allowableSpecilaChars, '');
    if (spaces > 0) {
      return this.message = this.GetTranslation('Common.Nospaces');
    }
    if (inValidChars !== '') {
      return this.message = this.GetTranslation("Common.Invalidcharacter") + inValidChars;
    }
    if (len > this.password_settings.maxLength) {
      return this.message = this.GetTranslation('Common.Passwordtoolong');
    }
    if ((specials + uppers + nums + lowers) < this.password_settings.minLength) {
      msg += this.password_settings.minLength - (specials + uppers + nums + lowers) + this.GetTranslation('Common.morecharacters');
    }
    if (specials == 0 || uppers == 0 || nums == 0 || lowers == 0) {
      msg += this.GetTranslation('Common.Atleast');
    }
    if (nums >= this.password_settings.numberLength) {
      nums = this.password_settings.numberLength;
    } else {
      msg += (this.password_settings.numberLength - nums) + this.GetTranslation('Common.morenumbers');
    }
    if (specials >= this.password_settings.specialLength) {
      specials = this.password_settings.specialLength;
    } else {
      msg += (this.password_settings.specialLength - specials) + this.GetTranslation('Common.Allowedspecial') + this.password_settings.specialChars + this.GetTranslation('Common.Allowedspecial1');
    }
    if (uppers >= this.password_settings.upperLength) {
      uppers = this.password_settings.upperLength;
    } else {
      msg += (this.password_settings.upperLength - uppers) + this.GetTranslation('Common.Uppercase');
    }
    if ((len - (uppers + specials + nums)) >= (this.password_settings.minLength - this.password_settings.numberLength - this.password_settings.specialLength - this.password_settings.upperLength)) {
      pStrength += (this.password_settings.minLength - this.password_settings.numberLength - this.password_settings.specialLength - this.password_settings.upperLength);
    } else {
      pStrength += (len - (uppers + specials + nums));
    }
    pStrength += uppers + specials + nums;

    if (lowers === 0) {
      if (pStrength > 1) {
        pStrength -= 1;
      }
      msg += this.GetTranslation('Common.lowercase');
    }
    if (pStrength == this.password_settings.minLength && lowers > 0) {
      msg = this.GetTranslation('Common.Strongpassword');
    }
    this.message = msg;
    return this.message;
  }
  public CountRegExp(passwordVal: string, regx: any) {
    const match = passwordVal.match(regx);
    return match ? match.length : 0;
  }
  public JsonParseData(data: any) {
    let result = data;
    try {
      result = JSON.parse(data ?? "null");
    } catch (e) {
    }
    return result;
  }
  public ReplaceLineBreak(str: string): string {
    if (str && typeof str === 'string') {
      str = str.replace(new RegExp('\r?<br/>', 'g'), '\n');
    }
    return str;
  }
  public GetNameAttribute(str: string): string {
    if (str != '' && str != null && str != undefined) {
      str = str.replace(/\s/g, '');
    }
    return str;
  }
  public isNullOrWhiteSpace(str: any): boolean {
    if (str == undefined || str == null || str.toString().trim() == "") {
      return true;
    }
    return false;
  }
  public isEqual(str1: string, str2: string, ignoreCase: boolean = false): boolean {
    if (ignoreCase) {
      return str1.toLowerCase() === str2.toLowerCase();
    } else {
      return str1 === str2;
    }
  }
  public isValidEmail(email: string): boolean {
    const regex = /^(?!.*’)(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regex.test(String(email).toLowerCase())) {
      return true;
    }
    return false;
  }
  public getBoolean(str: string): boolean {
    if (str == '' || str == null || str == undefined) {
      return false;
    }
    if (str == "1" || this.LowerCase(str) == "true")
      return true;

    return str == 'true';
  }
  public sanitizedHtml(html: string) {
    return this._sanitizer.sanitize(SecurityContext.HTML, html);
  }


  public decodeHTMLEntities(str: any) {
    const element = document.createElement('div');
    if (str && typeof str === 'string') {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }
    return str;
  }
  public normalizedFileName(fileName: string): string {
    if (!this.isNullOrWhiteSpace(fileName)) {
      fileName = fileName.replace(/[/\\?%*:|"<>]/g, '-');
    }
    return fileName;
  }

  public readClientConfiguration(key: string): string {
    let value = '';
    const clientConfigurations = this.JsonParseData(this.GetFromLocalStorage('clientConfigurations'));
    if (!this.isNullOrWhiteSpace(clientConfigurations) && clientConfigurations.length > 0) {
      var config = clientConfigurations.filter((x: any) => this.LowerCase(x.key) == this.LowerCase(key))[0];
      if (!this.isNullOrWhiteSpace(config)) {
        value = config.value;
      }
    }

    return value;
  }
  public getJTGO(): boolean {
    let isJTGO = false;
    const settings = this.JsonParseData(document.getElementById('setting-container')?.getAttribute("data-settings"));
    isJTGO = settings.ClientSetting.IsJTGO;
    return isJTGO;
  }




  public ReplaceNewLineToBr(str: string) {
    if (str && typeof str === 'string') {
      str = str.replace(/\n/g, '<br/>');
    }
    return str;
  }
  public replaceAll(str: string, find: string, replace: string): string | null {
    if (!this.isNullOrWhiteSpace(str))
      return str.replace(new RegExp(find, 'g'), replace);
    else
      return str;
  }

  public viewJobAdvert(jobId: number, jobAdvert: any, advertCount: number, jtUrl: string): void {
    let advert: string = "";
    let jobAdvertUrl: string = "";
    jobAdvertUrl = this.readClientConfiguration(ClientConfiguation.JobAdvertUrl)
    if (this.isNullOrWhiteSpace(jobAdvertUrl)) {
      jobAdvertUrl = "displayjob.aspx"
    }
    if (jobId > 0) {
      var url = jobAdvertUrl + '?jobid=' + jobId + "&isPreview=Yes";

      if (jobAdvert.external == "true") {
        advert = jobAdvert.external == "true" ? "1" : "";
      }
      if (jobAdvert.internal == "true") {
        advert = jobAdvert.internal == "true" ? "2" : "";
      }

      if (jobAdvert.agency == "true") {
        advert = jobAdvert.agency == "true" ? "3" : "";
      }
      if (advert == "2" && advertCount == 1) {
        url = 'internal/' + url;
      }
      if (advert == "2" && advertCount == 1)
        window.open(jtUrl + url + '&advert=internal', '_blank');
      else if (advert == "1" && advertCount == 1)
        window.open(jtUrl + url + '&advert=external', '_blank');
      else if (advert == "3" && advertCount == 1)
        window.open(jtUrl + url + '&advert=agency', '_blank');
      else
        window.open(jtUrl + url + '&advert=external', '_blank');
    }
  }
  public markPropertySafe(pageFields: any, fieldName: string) {
    for (var f in pageFields) {
      var pageField = pageFields[f];
      let propertyName = pageField.columnName;
      if (propertyName == fieldName)
        pageField["isSafe"] = true;
    }
  }

  markPropertySafeAndMakeLink(pageFields: SystemListingPageField[], listOfData: any, fieldNames: string[]) {

    const lowerCaseFieldNames = fieldNames.map(name => name.toLowerCase());
    const filteredPageFields = pageFields.filter((pageField: SystemListingPageField) =>
      lowerCaseFieldNames.includes(pageField.columnName.toLowerCase())
    );

    listOfData.forEach((data: any) => {
      this.setDefaultRowClass(data);

      filteredPageFields.forEach(pageField => {
        this.markPropertyAsSafe(pageField);
        this.markPropertyAsLink(data, pageField.columnName);
      });
    });
  }



  public loadTheme(key: string) {
    let htmlSelector = document.querySelector('html') as HTMLElement | null;

    let userConfig = this.GetFromLocalStorage("jt_user_info");
    if (userConfig) {
      let localConfiguration = this.JsonParseData(userConfig);

      if (htmlSelector != null && !this.isNullOrWhiteSpace(localConfiguration.theme)) {

        if (this.isNullOrWhiteSpace(key))
          htmlSelector.dataset.jtTheme = localConfiguration.theme;
        else {
          htmlSelector.dataset.jtTheme = key;
          localConfiguration.theme = key;
          this.SetLocalStorage('jt_user_info', JSON.stringify(localConfiguration))
        }
      }
    }

  }

  public initListingParams(): ListingParams {
    let listingParams = {} as ListingParams;
    listingParams.pageSize = 20;
    listingParams.systemPageId = -1;
    listingParams.searchType = 1;
    listingParams.isAscendingSort = true;
    listingParams.printSelectedRecords = true;
    listingParams.alternateRowinterface = true;
    listingParams.isTitleShow = true;
    listingParams.alternateRowinterface = true;
    listingParams.onRowClick = false;
    listingParams.customfieldValues = [];
    listingParams.gridTableClass = null;
    listingParams.isCustomMessageAction = true;
    return listingParams;
  }
  public getDatePickerOptions(options?: IAngularMyDpOptions): IAngularMyDpOptions {
    
    let dateFormat = this.GetDateFormat()?.toLowerCase();
    let defaultOptions: IAngularMyDpOptions = {
      todayTxt: 'Today',
      showFooterToday: true,
      dateFormat: dateFormat,
    };
    if (options)
      return { ...defaultOptions, ...options };
    else
      return defaultOptions;

  }
  public getParameterValueByName(name: string, url: string): string | null {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  public htmlEncode(html: string): string {
    let textArea = document.createElement('textarea');
    textArea.innerText = html;
    return textArea.innerHTML;
  }

  public encodeAndSanitizeHtml(html: any): string {
    html = this.sanitizedHtml(html);
    return this.htmlEncode(html);
  }


  public isGreaterThanZero(str: any): boolean {
    if (this.isNullOrWhiteSpace(str))
      return false;
    return parseInt(str) > 0
  }

  public scrollToTop(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  public getScoreOptions(n: number): number[] {
    let number = this.stringToInt(n?.toString());
    return Array(number + 1);
  }

  downLoadFileToWordDocument(fileInfo: FileInfo) {
    var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
    var footer = "</body></html>";
    var sourceHTML = header + fileInfo.content + footer;
    var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
    //For IE
    if (navigator.msSaveBlob) {
      return navigator.msSaveBlob(new Blob(['\ufeff', sourceHTML], { type: "application/vnd.ms-word;charset=utf-8" }), "document.doc");
    }
    var fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = 'document.doc';
    fileDownload.click();
    document.body.removeChild(fileDownload);

  }

  numberOnly(event: any): boolean {
    if (event.key === '.') {
      return false;
    }
    return true;
  }
  private setDefaultRowClass(data: any) {
    if (this.isNullOrWhiteSpace(data.rowClass)) {
      data.rowClass = "no-custom-class";
    }
  }

  private markPropertyAsSafe(pageField: SystemListingPageField) {
    pageField.isSafe = true;
  }

  private markPropertyAsLink(data: any, propertyName: string) {
    const value = data[propertyName];
    data[propertyName] = `<span class='link'>${this.sanitizedHtml(value)}</span>`;
  }


   getFormTypeValue(formTypeKey:string) {
     return IndexDBFormTypes[formTypeKey];
}

}

declare global {
  interface Date {
    withoutTime(): Date;
  }
}

Date.prototype.withoutTime = function () {
  let date = new Date(this);
  date.setHours(0, 0, 0, 0);
  return date;
}

